// extracted by mini-css-extract-plugin
module.exports = {"titleListWrapper":"zH","titleListTabWrapper":"zI","breakline":"zJ","tab":"zK","active":"zL","arrow":"zM","emblaSlide":"zN"};